import { openAlert } from './alertActions';
import { closeDialog } from './dialogActions';
import {
  getSubsriptions as callGetSubsriptions,
  getMemberships as callGetMemberships,
  getSubscribedMemberships as callGetSubscribed,
  subscribeToMembership as callSubscribeToMembership,
  cancelMembership as callCancelMemebership,
} from '../../../api/subscription';
import { snakeToCamel } from '../../../utils/object.js';
import { AppsflyerPBA } from '~/third_party/Appsflyer';

const BASE = 'subscriptions :';

export const subscriptionActionTypes = {
  getMembershipsStart: `${BASE} memberships : fetch start`,
  getMembershipsSuccess: `${BASE} memberships : fetch SUCCESS`,
  getMembershipsFailed: `${BASE} memberships : fetch AILED`,

  getSubscribedMembershipsStart: `${BASE} subscribed memberships : fetch start`,
  getSubscribedMembershipsSuccess: `${BASE} subscribed memberships : fetch SUCCESS`,
  getSubscribedMembershipsFailed: `${BASE} subscribed memberships : fetch FAILED`,

  subscribeToMembershipStart: `${BASE} subscribed memberships : persist start `,
  subscribeToMembershipSuccess: `${BASE} subscribed memberships : persist SUCCESS`,
  subscribeToMembershipFailed: `${BASE} subscribed memberships : persist FAILED`,

  cancelMembershipStart: `${BASE} cancel memberships : persist start`,
  cancelMembershipSuccess: `${BASE} cancel memberships : persist SUCCESS`,
  cancelMembershipFailed: `${BASE} cancel memberships : persist FAILED`,

  getSubscriptionsStart: `${BASE} subscriptions : fetch start`,
  getSubscriptionsSuccess: `${BASE} subscriptions : fetch SUCCESS`,

  getSubscriptionStart: `${BASE} subscription : fetch start`,
  getSubscriptionSuccess: `${BASE} subscriptions : fetch SUCCESS`,
};

export const getSubsriptions = (id) => async (dispatch) => {
  try {
    const { data } = await callGetSubsriptions(id);
    if (!id) {
      dispatch({
        type: subscriptionActionTypes.getSubscriptionsStart,
      });
      const { subscriptions } = snakeToCamel(data);
      dispatch({
        type: subscriptionActionTypes.getSubscriptionsSuccess,
        subscriptions,
      });
    } else {
      dispatch({
        type: subscriptionActionTypes.getSubscriptionStart,
      });
      const { subscription } = snakeToCamel(data);
      dispatch({
        type: subscriptionActionTypes.getSubscriptionSuccess,
        subscription,
      });
    }
  } catch (e) {
    dispatch(
      openAlert({
        variant: 'error',
        message: 'Failed to get user subscriptions',
      })
    );
  }
};

export const cancelMembership = (id, formData) => async (dispatch) => {
  try {
    dispatch({
      type: subscriptionActionTypes.cancelMembershipStart,
    });
    await callCancelMemebership(id, formData);
    AppsflyerPBA.trackWebmembershipUnsubscribe(formData);

    dispatch(closeDialog());
    dispatch(
      openAlert({
        variant: 'success',
        message: 'Successfully cancelled your membership',
      })
    );
    dispatch({ type: subscriptionActionTypes.cancelMembershipSuccess });
    dispatch(getSubsriptions());
  } catch (e) {
    dispatch(closeDialog());
    dispatch(
      openAlert({
        variant: 'error',
        message: 'Failed to cancel membership',
      })
    );
    dispatch({ type: subscriptionActionTypes.cancelMembershipFailed });
  }
};

export const getMemberships = () => async (dispatch) => {
  try {
    const { data: memberships } = await callGetMemberships();
    dispatch({
      type: subscriptionActionTypes.getMembershipsSuccess,
      memberships,
    });
  } catch (e) {
    dispatch({
      type: subscriptionActionTypes.getMembershipsFailed,
    });
  }
};

export const getSubscribedMemberships = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: subscriptionActionTypes.getSubscribedMembershipsStart,
    });

    const { data } = await callGetSubscribed(getState());
    dispatch({
      type: subscriptionActionTypes.getSubscribedMembershipsSuccess,
      subscribedMemberships: data,
    });
  } catch (e) {
    dispatch({
      type: subscriptionActionTypes.getSubscribedMembershipsFailed,
    });
  }
};

export const subscribeToMembership = (id, payment) => async (dispatch, getState) => {
  try {
    dispatch({
      type: subscriptionActionTypes.subscribeToMembershipStart,
    });
    const { data } = await callSubscribeToMembership(
      { id, identifier: payment.identifier },
      getState()
    );
    dispatch(
      openAlert({
        variant: 'success',
        message: 'You have successfully joined chowbus membership',
      })
    );
    dispatch({
      type: subscriptionActionTypes.subscribeToMembershipSuccess,
      data,
    });
    dispatch(closeDialog());
    dispatch(getSubsriptions());
    AppsflyerPBA.trackWebMembershipSubscribe();
  } catch (e) {
    let message = 'Failed to subscribe to membership';
    if (e.response) {
      message = e.response.data.errors ? e.response.data.errors : message;
    }
    dispatch({
      type: subscriptionActionTypes.subscribeToMembershipFailed,
    });
    dispatch(
      openAlert({
        variant: 'error',
        message,
      })
    );
    dispatch(closeDialog());
  }
};
